import React, {useEffect, useState} from "react";
import {Badge, Row} from "react-bootstrap";
import CardForm from "../../../components/form/CardForm";
import Title from "./Title";
import FormatPartFormConfig from "./FormatPartFormConfig";
import {BadgeTooltip} from "../../../components/tooltip/BadgeTooltip";

export function FormatPart(props) {

    const [initialized, setInitialized] = useState(false);
    const [expanded, setExpanded] = useState(false);


    function reInit() {
        setInitialized(false)
    }

    function initialize() {
        if (!initialized) {
            setInitialized(true)
        }
    }

    function toggled(toggled) {
        setExpanded(toggled)
    }

    function labels() {
        return (<div className={"float-right"}>
                {!!props.formatPart.contactWithProduct && !expanded &&
                    <BadgeTooltip tooltip={"Kontakt z produktem"} className={"mr-2"}>
                        <i className="fa-solid fa-tablets"></i>
                    </BadgeTooltip>
                }
                {!!props.formatPart.installationNumber && !expanded &&
                    <BadgeTooltip tooltip={"Numer instalacyjny"} className={"mr-2 h-100"}>
                        {props.formatPart.installationNumber}
                    </BadgeTooltip>
                }

                {!!props.formatPart.comment && !expanded &&
                    <BadgeTooltip tooltip={"Uwagi"} className={" h-100"}>
                        {props.formatPart.comment}
                    </BadgeTooltip>
                }
            </div>
        )
    }

    useEffect(initialize, [initialized])

    return <>


        {initialized &&
            <Row>
                <CardForm
                    title={<Title
                        name={props.formatPart.name}
                        tooltipImage={props.formatPart.files[0]}
                        labels={labels()}
                    />}
                    setLoader={props.setLoader}
                    fields={FormatPartFormConfig}
                    width={12}
                    withoutPadding={true}
                    initialData={props.formatPart}
                    editable={props.editable !== false}
                    readOnly={props.readOnly}
                    api={"formatPart/" + props.formatPart.id}
                    withToggle={true}
                    onToggleChange={toggled}
                    disableCleanAfterSave={true}
                    reInit={reInit}
                    performReload={props.reloadLine}
                    hideIfNull={true}
                />
            </Row>
        }
    </>;
}